import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import appConfig from "../../../config/appConfig";

import Products from "./Products";
import Plans from "./Plans";
import Tiers from "./Tiers";
import Settings from "./Settings";
import Payouts from "./Payouts";
import Transactions from "./Transactions";

const BillingRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="tiers" replace />} />
            <Route path="/products" element={<><Sidebar /><Products pageTitle={appConfig.pageTitle("Products · Admin")} /></>} />
            <Route path="/plans" element={<><Sidebar /><Plans pageTitle={appConfig.pageTitle("Plans · Admin")} /></>} />
            <Route path="/tiers" element={<><Sidebar /><Tiers pageTitle={appConfig.pageTitle("Tiers · Admin")} /></>} />
            <Route path="/transactions" element={<><Sidebar /><Transactions pageTitle={appConfig.pageTitle("Transactions · Admin")} /></>} />
            <Route path="/payouts" element={<><Sidebar /><Payouts pageTitle={appConfig.pageTitle("Payouts · Admin")} /></>} />
            <Route path="/settings" element={<><Sidebar /><Settings pageTitle={appConfig.pageTitle("Billing settings · Admin")} /></>} />
        </Routes>
    );
};

export default BillingRouter;
